import { render, staticRenderFns } from "./AdminRemoteCard.vue?vue&type=template&id=32ca01b9&scoped=true"
import script from "./AdminRemoteCard.vue?vue&type=script&lang=js"
export * from "./AdminRemoteCard.vue?vue&type=script&lang=js"
import style0 from "./AdminRemoteCard.vue?vue&type=style&index=0&id=32ca01b9&prod&lang=scss&scoped=true"
import style1 from "./AdminRemoteCard.vue?vue&type=style&index=1&id=32ca01b9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ca01b9",
  null
  
)

export default component.exports